import { HeartIcon as HeartOutline } from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid";
import { BookmarkIcon as BookmarkOutline } from "@heroicons/react/24/outline";
import { BookmarkIcon as BookmarkSolid } from "@heroicons/react/24/solid";
import {
  ChatBubbleOvalLeftIcon,
  ShareIcon,
  EllipsisHorizontalIcon,
} from "@heroicons/react/24/outline";
import avatar from "../../assets/images/Avatar.avif"
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/ar";
import "dayjs/locale/en";
import { useDispatch, useSelector } from "react-redux";
import { toggleLike } from "../../slices/5-like/thunk";
import { toggleBookmark } from "../../slices/4-bookmark/thunk";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

const CompanyPost = ({
  post,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // console.log(post)
  const { i18n } = useTranslation();

  const locale = i18n.language === "ar" ? "ar" : "en";
  const { profile } = useSelector((state) => state.myProfile);

  const handleShare = async () => {
    const url = `${window.location.origin}/post/${post?.id}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: post?.title || "Check this post",
          text: post?.content?.slice(0, 100) || "Interesting post",
          url,
        });
      } catch (err) {
        // console.log("Share cancelled", err);
      }
    } else {
      await navigator.clipboard.writeText(url);
    }
  };

  // console.log(profile?.Companies?.[0]?.id)
  // console.log(post)
  return (
    <div
      className="overflow-hidden duration-300 border bg-bg-light-secondary border-border-light rounded-xl hover:shadow-glow dark:bg-bg-dark-secondary dark:border-border-dark"
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center gap-3 cursor-pointer"
          onClick={() => {
            if (profile?.Companies?.[0]?.id === post?.Company?.id) {
              navigate(`/mycompany`)

            } else {
              navigate(`/profile-company/${post?.Company?.slug}`)
            }
          }}
        >
          <img
            src={post?.Company?.logo || avatar}
            alt="avatar"
            className="w-10 h-10 border-2 rounded-full border-border-light dark:border-border-dark"
          />
          <div>
            <p className="font-semibold text-gray-900 dark:text-gray-100">
              {locale === "ar" ? post?.Company?.name_AR : post?.Company?.name_EN}
            </p>
            <p className="text-xs text-text-muted-light dark:text-text-muted-dark">
              {dayjs(post?.createdAt).locale(locale).fromNow()}
            </p>
          </div>
        </div>

        <button className="p-2 duration-300 rounded-xl dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary group">
          <EllipsisHorizontalIcon className="w-5 h-5 duration-300 text-text-muted-light dark:text-text-muted-dark dark:group-hover:text-primary group-hover:text-primary-light" />
        </button>
      </div>

      {/* Text */}
      <div className="px-4 pb-3">
        <p className="text-sm text-gray-700 cursor-pointer dark:text-gray-300"
          onClick={() => navigate(`/post/${post?.id}`)}

        >{post?.text}</p>
        {/* <p className="text-sm text-gray-700 dark:text-gray-300">{post.description}</p> */}
      </div>

      {/* Image */}
      {
        post?.image &&
        <img src={post?.image} alt="iamge post" className="object-cover w-full h-64 cursor-pointer"
          onClick={() => navigate(`/post/${post?.id}`)}

        />
      }

      {/* Actions */}
      <div className="flex items-center justify-between p-4 text-gray-500 dark:text-gray-400">
        <div className="flex items-center gap-2">
          {/* LOVE */}
          <div
            onClick={() => {
              dispatch(toggleLike(post?.id));
            }}
            className="flex items-center gap-2 p-2 duration-300 rounded-lg cursor-pointer dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary"
          >
            {post?.liked ? (
              <HeartSolid className="w-5 h-5 text-red-500" />
            ) : (
              <HeartOutline className="w-5 h-5 text-red-500" />
            )}
            <span className="text-sm text-red-500">
              {Math.max(0, post?.likeCount || 0)}
            </span>
          </div>

          {/* COMMENT */}
          <div className="flex items-center gap-2 p-2 duration-300 rounded-lg cursor-pointer dark:hover:text-primary hover:text-primary-light dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary"
            onClick={() => navigate(`/post/${post?.id}`)}

          >
            <ChatBubbleOvalLeftIcon className="w-5 h-5" />
            <span className="text-sm">{post?.Comments?.length}</span>
          </div>

          {/* SHARE */}
          <div className="flex items-center gap-2 p-2 duration-300 rounded-lg cursor-pointer dark:hover:text-primary hover:text-primary-light dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary "
            onClick={handleShare}
          >
            <ShareIcon className="w-5 h-5" />
            {/* <span className="text-sm">{post?.sharesCount}</span> */}
          </div>
        </div>

        {/* BOOKMARK */}
        <div
          onClick={() => {
            dispatch(toggleBookmark(post?.id));
          }}
          className="p-2 duration-300 rounded-lg cursor-pointer dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary"
        >
          {post?.bookmarked ? (
            <BookmarkSolid className="w-5 h-5 dark:text-primary text-primary-light" />
          ) : (
            <BookmarkOutline className="w-5 h-5 dark:text-primary text-primary-light" />
          )}
        </div>
      </div>
    </div >
  );
};
export default CompanyPost;
